/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M104.469 32.004c-.45.05-.867.246-1.188.562l-45.25 45.25a2.018 2.018 0 0 0-.593 1.22l-1.406 12.718a2.003 2.003 0 0 0 2.218 2.219l12.72-1.438c.448-.046.866-.246 1.187-.562l45.25-45.25a2.001 2.001 0 0 0 0-2.844l-11.312-11.312a2.006 2.006 0 0 0-1.625-.562l-.001-.001zm.219 4.812l8.5 8.5-43.312 43.312-9.594 1.063 1.062-9.531 43.344-43.344zM34 42.004c-1.172.035-1.977 1.098-2 2v72c0 1.047.953 2 2 2h72c1.047 0 2-.953 2-2v-43c.015-1.059-.942-2.031-2-2.031-1.059 0-2.016.972-2 2.03v41H36v-68h41c1.054.017 2.031-.94 2.031-2 0-1.058-.973-2.015-2.031-2H34z"/>'
  }
})
